import React, { useState, useEffect, useContext, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "js-cookie";
import { Context } from "../../../../../utils/context";
import { postData, getData } from "../../../../../utils/api";
import { AppSetup } from "../../../../../utils/apis/common/Common";
import Select from "react-select";

const Step_Two_New = ({ prevStep, nextStep }) => {
  const { getData: contextGetData, Select2Data } = useContext(Context);

  const [setups, setSetup] = useState({});
  const [selectedRole, setSelectedRole] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [categories, setCategories] = useState([]);
  const [hasSavedPassword, setHasSavedPassword] = useState(false); // Track if password exists in DB

  const mapRef = useRef(null);
  const searchInputRef = useRef(null);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);

  const user_id = Cookies.get("seller_user_id") || "";

  useEffect(() => {
  if (!window.google || !mapRef.current || map) return;

  const defaultCenter = { lat: 18.5204, lng: 73.8567 };

  const mapInstance = new window.google.maps.Map(mapRef.current, {
    center: defaultCenter,
    zoom: 15,
    mapTypeControl: false,
    streetViewControl: false,
  });

  const markerInstance = new window.google.maps.Marker({
    position: defaultCenter,
    map: mapInstance,
    draggable: true,
  });

  // 🔍 Autocomplete
  const autocomplete = new window.google.maps.places.Autocomplete(
    searchInputRef.current
  );

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    if (!place.geometry) return;

    if (place.formatted_address) {
  setValue("store_address", place.formatted_address);
}

    const location = place.geometry.location;
    const lat = location.lat();
    const lng = location.lng();

    mapInstance.panTo({ lat, lng });
    markerInstance.setPosition({ lat, lng });

    setValue("latitude", lat.toFixed(6));
    setValue("longitude", lng.toFixed(6));
  });

  // Click on map
  mapInstance.addListener("click", (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    markerInstance.setPosition({ lat, lng });

    setValue("latitude", lat.toFixed(6));
    setValue("longitude", lng.toFixed(6));
  });

  setMap(mapInstance);
  setMarker(markerInstance);
}, []);

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const togglePasswordVisibility1 = () => setShowPassword1(!showPassword1);

  const handleRadioChange = (e) => {
    setSelectedRole(e.target.id);
    clearErrors("role");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Load commission
  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) setSetup(res.data);
  };

  // Load categories
  const loadCategories = async () => {
    try {
      const res = await contextGetData("/without-login/allcategories");
      if (res?.success) {
        const opts = await Select2Data(res.data, "category_id", false);
        setCategories(opts);
      }
    } catch (err) {}
  };

  // Load saved draft
  const getEditData = async () => {
    if (!user_id) return;

    try {
      const res = await contextGetData(`/seller/seller-detail/${user_id}`);
      if (res?.success) {
        const d = res.data.seller_detail || {};

        setSelectedRole(d.role_type || "");
        setHasSavedPassword(!!d.password); // True if password exists

        reset({
          password: "",
          c_password: "",
          longitude: d.longitude || "",
          latitude: d.latitude || "",
          store_address: d.store_address || "",
          category_id: null,
          manager_name: d.manager_name || "",
          manager_email: d.manager_email || "",
          manager_contact_no: d.manager_contact_no || "",
        });

        // if (d.category_id) {
        //   const cat = categories.find((c) => c.value == d.category_id);
        //   if (cat) setValue("category_id", cat);
        // }

        if (res.data.seller_categories?.length) {
          const selectedCats = res.data.seller_categories
            .map((sc) => categories.find((c) => c.value === sc.category_id))
            .filter(Boolean);

          setValue("category_id", selectedCats);
        }

        

      }
    } catch (err) {}
  };

  useEffect(() => {
  if (!map || !marker) return;

  const lat = watch("latitude");
  const lng = watch("longitude");

  if (lat && lng) {
    const position = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    map.setCenter(position);
    marker.setPosition(position);
  }
}, [map, marker, watch("latitude"), watch("longitude")]);

  useEffect(() => {
    getSetup();
    loadCategories();
  }, []);

  useEffect(() => {
    if (user_id) getEditData();
  }, [user_id, categories, map]);

  // Initialize Google Map
  useEffect(() => {
    if (!window.google || !mapRef.current || map) return;

    const defaultCenter = { lat: 18.5204, lng: 73.8567 };
    const mapInstance = new window.google.maps.Map(mapRef.current, {
      center: defaultCenter,
      zoom: 15,
      mapTypeControl: false,
      streetViewControl: false,
    });

    const markerInstance = new window.google.maps.Marker({
      position: defaultCenter,
      map: mapInstance,
      draggable: true,
    });

    mapInstance.addListener("click", (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      markerInstance.setPosition({ lat, lng });
      setValue("latitude", lat.toFixed(6));
      setValue("longitude", lng.toFixed(6));
    });

    setMap(mapInstance);
    setMarker(markerInstance);
  }, []);

  const onSubmit = async (data) => {
    if (!selectedRole) {
      setError("role", { message: "Role is required" });
      return;
    }

    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("role_type", selectedRole);
    formData.append("longitude", data.longitude || "");
    formData.append("latitude", data.latitude || "");
    formData.append("store_address", data.store_address);
    // formData.append("category_id", data.category_id?.value || "");
    const categoryIds = (data.category_id || []).map((c) => c.value);

    formData.append("category_id", JSON.stringify(categoryIds));

    // Only send password if it's the first time or user typed a new one
    if (!hasSavedPassword || (data.password && data.password.trim() !== "")) {
      if (!data.password || data.password !== data.c_password) {
        setError("c_password", { message: "Passwords do not match" });
        return;
      }
      formData.append("password", data.password);
    }

    if (selectedRole === "Manager") {
      formData.append("manager_name", data.manager_name);
      formData.append("manager_email", data.manager_email);
      formData.append("manager_contact_no", data.manager_contact_no);
    }

    try {
      const res = await postData("/seller/add-two", formData);
      if (res?.success) {
        setHasSavedPassword(true); // Mark password as saved
        alert("Step 2 saved successfully!");
        nextStep();
      } else {
        alert(res?.message?.errors?.[0]?.msg || "Failed to save");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <section className="personal-details-form userForm">
        <div className="warning_div">
          <p className="warning_text">
            Please take a note, {setups?.commission_percent || 0}% of gross
            commission and onboarding fees ₹{setups?.onboarding_fees || 0}/-
            will be applicable to your business.
          </p>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* Role */}
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="field-bottom">
                <Form.Label className="required form-field">
                  Select Role
                </Form.Label>
                <div className="row get-otp-text">
                  <div className="row get-otp-text">
                    <div className="col-lg-6">
                      <Form.Check
                        type="radio"
                        label="Owner"
                        id="Owner"
                        checked={selectedRole === "Owner"}
                        onChange={handleRadioChange}
                      />
                    </div>
                    <div className="col-lg-6">
                      <Form.Check
                        type="radio"
                        label="Manager"
                        id="Manager"
                        checked={selectedRole === "Manager"}
                        onChange={handleRadioChange}
                      />
                    </div>
                    {!selectedRole && errors.role && (
                      <span className="text-danger">{errors.role.message}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Password Fields - Always visible */}
          <div className="row">
            <div className="col-md-6">
              <div className="field-bottom">
                <Form.Label className="required">Create Password*</Form.Label>
                <div className="password_div">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder={
                      hasSavedPassword
                        ? "Leave blank to keep current"
                        : "Enter password"
                    }
                    {...register("password", {
                      required: !hasSavedPassword
                        ? "Password is required"
                        : false,
                    })}
                    className={classNames("", {
                      "is-invalid": errors.password,
                    })}
                  />
                  <FontAwesomeIcon
                    icon={showPassword ? faEyeSlash : faEye}
                    className="eyeicn"
                    onClick={togglePasswordVisibility}
                  />
                </div>
                {errors.password && (
                  <span className="text-danger">{errors.password.message}</span>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="field-bottom">
                <Form.Label className="required">Confirm Password*</Form.Label>
                <div className="password_div">
                  <Form.Control
                    type={showPassword1 ? "text" : "password"}
                    placeholder={
                      hasSavedPassword
                        ? "Leave blank to keep current"
                        : "Confirm password"
                    }
                    {...register("c_password", {
                      required: !hasSavedPassword
                        ? "Please confirm password"
                        : false,
                      validate: (value) => {
                        if (
                          !hasSavedPassword &&
                          watch("password") &&
                          value !== watch("password")
                        ) {
                          return "Passwords do not match";
                        }
                        return true;
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors.c_password,
                    })}
                  />
                  <FontAwesomeIcon
                    icon={showPassword1 ? faEyeSlash : faEye}
                    className="eyeicn"
                    onClick={togglePasswordVisibility1}
                  />
                </div>
                {errors.c_password && (
                  <span className="text-danger">
                    {errors.c_password.message}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Manager Fields */}
          {selectedRole === "Manager" && (
            <div className="row">
              <div className="col-md-6">
                <div className="field-bottom">
                  <Form.Label className="required form-field">
                    Manager Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    {...register("manager_name", { required: "Required" })}
                  />
                  {errors.manager_name && (
                    <span className="text-danger">
                      {errors.manager_name.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="field-bottom">
                  <Form.Label className="required form-field">
                    Manager Email ID
                  </Form.Label>
                  <Form.Control
                    type="email"
                    {...register("manager_email", { required: "Required" })}
                  />
                  {errors.manager_email && (
                    <span className="text-danger">
                      {errors.manager_email.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="field-bottom">
                  <Form.Label className="required form-field">
                    Manager Contact Number
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={10}
                    {...register("manager_contact_no", {
                      required: "Required",
                    })}
                  />
                  {errors.manager_contact_no && (
                    <span className="text-danger">
                      {errors.manager_contact_no.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Location Search */}
          <div className="mb-3">
            <Form.Control
              type="text"
              placeholder="Search location..."
              ref={searchInputRef}
            />
          </div>

          {/* Map */}
          <div style={{ width: "100%" }} className="mb-4">
            <Form.Label className="required form-field">
              Shop Location
            </Form.Label>
            <div
              ref={mapRef}
              style={{
                width: "100%",
                height: "350px",
                borderRadius: "12px",
                border: "2px solid #ddd",
                overflow: "hidden",
              }}
            />
            <small className="text-muted">Click on map to set location</small>
          </div>

          {/* Lat/Lng */}
          <div className="row">
            <div className="col-md-6">
              <div className="field-bottom">
                <Form.Label className="required form-field">
                  Longitude
                </Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  // {...register("longitude")}
                  {...register("longitude", {
                    required: "longitude required",
                  })}
                  placeholder="Auto-filled"
                />
                {errors.longitude && (
                  <span className="text-danger">
                    {errors.longitude.message}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="field-bottom">
                <Form.Label className="required form-field">
                  Latitude
                </Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  {...register("latitude", {
                    required: "latitude required",
                  })}
                  placeholder="Auto-filled"
                />
                {errors.latitude && (
                  <span className="text-danger">{errors.latitude.message}</span>
                )}
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="row">
            <div className="col-md-12">
              <div className="field-bottom">
                <Form.Label className="required form-field">
                  Store Address
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  {...register("store_address", {
                    required: "Address Required",
                  })}
                />
                {errors.store_address && (
                  <span className="text-danger">
                    {errors.store_address.message}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Category */}
          <div className="row">
            <div className="col-md-6">
              <div className="field-bottom">
                <Form.Label className="required form-field">
                  Business Category
                </Form.Label>

                <Controller
                  name="category_id" // name of the field
                  {...register("category_id", {
                    required: "Select Category",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      isMulti
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.category_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={categories}
                    />
                  )}
                />
                {errors.category_id && (
                  <span className="text-danger">
                    {errors.category_id.message}
                  </span>
                )}

                {/* <Select
                  options={categories}
                  isMulti
                  onChange={(opts) => setValue("category_id", opts)}
                  value={watch("category_id") || []}
                  placeholder="Select Categories"
                  isSearchable
                /> */}
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="col-md-12">
            <div className="text-start apply_now_btn">
              <div className="registerContinueMain">
                <Button onClick={prevStep} className="back-btn me-3">
                  Back
                </Button>
                <Button type="submit" className="tabs-btn">
                  Next
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </section>
    </>
  );
};

export default Step_Two_New;
